import React, { Component, Fragment } from 'react'
import {
    List,
    CardActions,
    CreateButton,
    RefreshButton,
    Filter,
    SearchInput,
    NumberInput,
    TextInput,
    SelectInput,
    ReferenceInput,
    // AutocompleteInput,
} from 'react-admin'
import { renderModelFields } from '../Fields'
import { ReferenceSelectInput } from '../Inputs'
import Datagrid from './Datagrid'
import Title from './Title'
import { 
    // DownloadExcelReport, 
    UploadBulkLoadExcel,
    DownloadBulkLoadExcel,
    DownloadBulkLoadExcelInstalaciones,
    UploadBulkLoadInstalacionExcel } from '../Actions'

import { RowActions } from '../Generic'


class Filters extends Component {
  constructor (props) {
    super(props)
    this.state = {filter: {}};
  }
  handleSetFilters = (filter) => {
    this.setState({ filter })
    if (JSON.stringify(filter).indexOf('_id') > -1) {
      this.props.setFilters(filter)
    }
  }
  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      const { filter } = this.state
      this.props.setFilters(filter)
    }
  }
  render () {
    const { permissions: { role } } = this.props
    return (
      <div>
          {/* <Button label={"Filtrar"}><SearchIcon/>Filtrar</Button> */}
        <Filter { ...this.props } setFilters={this.handleSetFilters} onKeyDown={this.handleKeyDown}>
            <SearchInput source="search" alwaysOn />
            <SelectInput source="validacionbbdd" label="Val BBDD" choices={[
                { id: '1', name: 'Validado' },
                { id: '2', name: 'Rechazado' },
                { id: '3', name: 'En Uso' },
                { id: '4', name: 'No Validado' },
            ]} />
            <SelectInput source="validacionactivos" label="Val Activos" choices={[
                { id: '1', name: 'Validado' },
                { id: '2', name: 'Rechazado' },
                { id: '3', name: 'En Uso' },
                { id: '4', name: 'No Validado' },
            ]} />
            <NumberInput source="id" label="ID" />
            <NumberInput source="inf_id" label="Inf. ID" />
            <NumberInput source="ref_id" label="Ref. ID" />
            <TextInput source="name__icontains" label="Nombre" />
            <TextInput source="description__icontains" label="Descripción" />
            {["admin", "coordinador", "externo"].includes(role)
                && (
                    <SelectInput source="status" choices={[
                        { id: 'EN_OPERACION', name: 'EN OPERACIÓN' },
                        { id: 'EN_PROYECTO', name: 'EN PROYECTO' },
                        { id: 'FUERA_OPERACION', name: 'FUERA DE OPERACIÓN' },
                    ]} />
                )
            }
            <ReferenceSelectInput
                label="Propietarios"
                source="propietario_id"
                placeholder="Propietarios"
                reference="empresas"
                sort={{ field: 'name', order: 'ASC' }}
                filterToQuery={searchText => ({ name: searchText })}
                clearOnClick={true}
            />
            <ReferenceSelectInput
                label="Decretos"
                source="decreto_id"
                reference="decretos"
                sort={{ field: 'name', order: 'ASC' }}
                filterToQuery={searchText => ({ name: searchText })}
                clearOnClick={true}
            />
            <ReferenceInput label="Categoria VU" source="categoria_vu_id" reference="categorias-vida-util">
                <SelectInput optionText="name" />
            </ReferenceInput>
        </Filter>
      </div>
    )
  }
}
const instalacionesActivas = ["subestaciones","patios-subestaciones","barras","panos",
"elementos-comunes-panos","tableros","armarios","lineas","circuitos","tramos","vanos","accesorios-vanos",
"estructuras-subestaciones","accesorios-estructuras-subestaciones","torres","marcos-lineas",
"accesorios-estructuras-lineas-aereas","accesorios-estructuras-lineas-subterraneas","oocc",
// instalaciones segunda entrafa D.ROMEROA 31-01-22
    "elementos-comunes-ssee","elementos-comunes-patios","transformadores-2d","transformadores-3d",
    "interruptores",
    "desconectadores",
    "transformadores-corriente",
    "transformadores-potencial",
    "transformadores-ssaa",
    "pararrayos",
    "trampas-ondas",
    "aisladores",
    "medidores",
    "casas-servicios-generales-y-casetas",
    "bancos-baterias",
    "generadores-energia",
    "elementos-comunes-ssgg-casetas",
    "equipos-principales-comunicacion",
    "reles-proteccion",
    "sistemas-respaldo-energia",
    "estaciones-repetidoras",
    "reactores",
    "dispositivos-reconexiones",
    "bancos-condensadores",
    "compensadores-estaticos-reactivos",
    "compensadores-activos",
    "condensadores-series",
    "condensadores-sincronos",
    "multiplexadores",
    "otros-elementos-telecomunicaciones",
    "otros-elementos-sistemas-proteccion",
    "controladores-bahia",
    "otros-elementos-sistemas-control",
    "elementos-comunes-armarios",
    "servidumbres",
    "paneles-antirruido",
    "pararrayos-mufas",
    "mitigaciones-ambientales",
    "camaras",
    "estructuras-lineas",
    "mufas",
    "estudios-impacto-ambiental",
    "tuneles",
    'patios-mufas',
    "celdas",
    "transformadores-zigzag"
]

const GenericListActions = ({
    bulkActions,
    basePath,
    currentSort,
    displayedFilters,
    // exporter,
    filters,
    filterValues,
    onUnselectItems,
    resource,
    selectedIds,
    showFilter,
    total,
    permissions
}) => (
    <CardActions>
        
        {instalacionesActivas.includes(resource) 
        && ["admin", "coordinador", "externo"].includes(permissions.role) &&
        !["empresas", "grupos"].includes(resource) &&
        <DownloadBulkLoadExcelInstalaciones resource={resource} />}
        
        {instalacionesActivas.includes(resource) 
        && ["admin", "coordinador", "externo"].includes(permissions.role) &&
        !["empresas", "grupos"].includes(resource) &&
        <UploadBulkLoadInstalacionExcel resource={resource} />}

        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
        
        {["admin", "coordinador"].includes(permissions.role)
            && <CreateButton basePath={basePath} label={"Nuevo"}/>}
        {/* <ExportButton
            disabled={total === 0}
            resource={resource}
            sort={currentSort}
            filter={filterValues}
            exporter={exporter}
            label={"Exportar"}
        /> */}
        <RefreshButton label={"Actualizar"}/>
        
        {["admin", "coordinador", "externo", "coordinado"].includes(permissions.role) &&
        !["empresas", "grupos"].includes(resource) &&
        <UploadBulkLoadExcel resource={resource} />}

        {!["empresas", "grupos"].includes(resource) &&
        <DownloadBulkLoadExcel resource={resource} />}

        {/* <DownloadExcelReport resource={resource} /> */}
        
    </CardActions>
);

class GenericList extends Component {
    render() {
        const { fields, title } = this.props
        if (!!fields && fields.length === 0) {
            return null
        } else if (this.props.permissions === null) {
            return null
        } else {
            return (
                <Fragment>
                    <Title title={title} />
                    <List
                        {...this.props}
                        filters={<Filters permissions={this.props.permissions}/>}
                        actions={<GenericListActions permissions={this.props.permissions}/>}
                    >
                        <Datagrid>
                            {renderModelFields(fields, this.props.permissions)}
                            <RowActions permissions={this.props.permissions}/>
                        </Datagrid>
                    </List>
                </Fragment>
            )
        }
    }
}

export default GenericList
